export default {
  buttons: {
    back: 'Tilbage',
  },
};
